module.exports = __webpack_public_path__ + "img/facebook-f.9d89bf81.svg";